import * as React from 'react';

import warning from '~shared/utils/warning';

import { TAB_PANELS_UPDATED } from './actions';
import { TabPanel, TabPanelProps } from './TabPanel';
import { TabsContext } from './TabsProvider';

interface TabPanelsContextValues {
  panelIndex: number;
}

export const TabPanelsContext =
  React.createContext<TabPanelsContextValues | null>(null);

interface TabPanelsProps {
  children: React.ReactElement<TabPanelProps>[];
}

/**
 * @deprecated Use the TabsV2 components instead.
 */
export function TabPanels({ children }: TabPanelsProps) {
  const tabsContext = React.useContext(TabsContext);

  if (!tabsContext) {
    throw new Error('TabPanels rendered outside TabsProvider context');
  }

  const { dispatch } = tabsContext;
  const panels = React.Children.toArray(children)
    .filter((child) => child)
    .map((panel: React.ReactElement, index) => {
      warning(
        typeof panel === 'object' && panel.type === TabPanel,
        'Only TabPanel elements can be direct children of a TabPanels'
      );

      return (
        <TabPanelsContext.Provider
          key={index}
          value={{
            panelIndex: index,
          }}
        >
          {panel}
        </TabPanelsContext.Provider>
      );
    });

  const panelItems: Array<number> = [...Array(panels.length).keys()];

  React.useEffect(() => {
    dispatch({ type: TAB_PANELS_UPDATED, panels: panelItems });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panelItems.join(), dispatch]);

  return <>{panels}</>;
}
